<template>
  <div>
    <form @submit.prevent="submitForm" class="ui-form" method="POST">
      <div class="row login__columns mt-md-4 mt-0">
        <div class="col-12" data-wronged="">
          <div class="login__input-wrapper">
            <input
              type="email"
              id="email"
              v-model="form.email"
              autocomplete="off"
              name="email"
            />
            <label for="email" class="label_form"> E-mail </label>
          </div>
        </div>
        <div class="col-12" data-wronged="">
          <div class="login__input-wrapper">
            <input
              type="password"
              id="password"
              v-model="form.password"
              autocomplete="off"
              name="password"
            />
            <label for="password" class="label_form"> Senha </label>
          </div>
        </div>
      </div>
      <div class="row">
        <div class="col-md-6 col-12 login__submit">
          <button type="submit" class="ui-button--blue" id="submit-button">
            {{ button }}
          </button>
        </div>
        <div class="col-12 d-md-block d-flex justify-content-center">
          <password
            :endpoint="endpoint"
            :check_email="check_email"
            :send_recover="send_recover"
          ></password>
        </div>
      </div>
    </form>
  </div>
</template>

<script>
import axios from "axios";
import ForgotPassword from "./TheForgotPassword";
import LogHelper from "./Helpers/LogHelper";

export default {
  props: [
    "login_endpoint",
    "home_endpoint",
    "endpoint",
    "check_email",
    "send_recover",
  ],
  components: {
    password: ForgotPassword,
  },
  data() {
    return {
      form: {
        email: "",
        password: "",
      },
      button: "Entrar",
    };
  },
  methods: {
    submitForm() {
      if (this.isFormOk()) {
        this.button = "Aguarde, estamos logando você...";
        var submit_button = document.getElementById("submit-button");
        submit_button.disabled = true;
        axios
          .post(this.login_endpoint, {
            email: this.form.email,
            password: this.form.password,
          })
          .then((response) => {
            if (response.data[1]) {
              this.$swal({
                title: "Você está logado(a) :)",
                text: "Você foi oficialmente logado na A9.",
                type: "success",
                allowOutsideClick: false,
                showConfirmButton: false,
              });
            }
            this.button = "Você está logado(a) :)";
            if (location.pathname.split("/")[2] == "carrinho") {
              if (response.data[1]) {
                this.$emit("loginStep", this.form.email);
              }
              this.$swal.close();
            }
            this.setWithExpiry(
              "__AUTH",
              response.data[0],
              1296000000,
              response.data[1]
            );

            if (!response.data[1]) {
              this.$swal({
                title: "Você está logado(a)",
                text: "Mas antes de continuar, por favor, vá até 'Configurações de Conta' (ou clique no botão abaixo) e complete seu cadastro para poder continuar com a suas compras.",
                type: "success",
                confirmButtonText: "Completar cadastro",
                allowOutsideClick: false,
                showConfirmButton: true,
              }).then((result) => {
                if (result.value) {
                  window.location.href = "/cliente/minha-conta";
                }
              });
            }
          })
          .catch((e) => {
            if (e.response.data.email) {
              var item = document.getElementById("email");
              this.assignError(item, e.response.data.msg);
              this.button = "Entrar";
              submit_button.removeAttribute("disabled");
            } else if (e.response.data.password) {
              var item = document.getElementById("password");
              this.assignError(item, e.response.data.msg);
              this.button = "Entrar";
              submit_button.removeAttribute("disabled");
            } else {
              this.$swal({
                title: "Oops :|",
                text: "Tivemos um pequeno problema. Por favor, tente novamente mais tarde ou nos chame no chat que aparece na home do site.",
                showCancelButton: false,
                confirmButtonText: "Ok",
                confirmButtonColor: "#6fe335",
              });
            }
          })
          .finally(() => {
            this.button = "Entrar";
          });
      }
    },
    setWithExpiry(key, value, ttl, has_completed_signup = true) {
      const now = new Date();
      const item = {
        value: value,
        expiry: now.getTime() + ttl,
      };
      localStorage.setItem(key, JSON.stringify(item));
      if (
        location.pathname.split("/")[2] != "carrinho" &&
        has_completed_signup
      ) {
        window.location.href = "/cliente/carrinho";
      } else {
        axios.post("/api/cart/attribution", {
          temp: localStorage.getItem("__TMP"),
          client_id: JSON.parse(localStorage.getItem("__AUTH")).value,
          post_attribution: true,
        });
      }
    },
    isFormOk() {
      this.removeErrorMessages();

      var is_ok = true;
      var email = document.getElementById("email");
      var password = document.getElementById("password");

      //Checks if the email is not empty
      if (email.value.length < 1) {
        const message = "É obrigatório um e-mail para logar";
        this.assignError(email, message);
        is_ok = false;
        LogHelper.sendLogToGoogleChat(`Formulário de Login | ${message}`, 406);
      }

      //Cheks if the password is not empty
      if (password.value.length < 1) {
        const message = "É obrigatório uma senha para logar";
        this.assignError(password, message);
        is_ok = false;
        LogHelper.sendLogToGoogleChat(`Formulário de Login | ${message}`, 406);
      }

      return is_ok;
    },
    removeErrorMessages() {
      //Removes all error messages from the inputs
      var items = document.getElementsByClassName("ui-wronged");
      for (var i = items.length - 1; i >= 0; i--) {
        items[items.length - 1].classList.remove("ui-wronged");
      }
    },
    assignError(element, message) {
      //Assign an error message
      element.parentElement.dataset.wronged = message;
      element.parentElement.classList.add("ui-wronged");
    },
  },
};
</script>
<style scoped lang="scss">
.label_form {
  background-color: white !important;
  top: -8px !important;
}
</style>